import {testIdProps} from '@github-ui/test-id-props'
import SidebarHeading from '@github-ui/marketplace-common/SidebarHeading'
import type {Labels} from '../../routes/playground/components/types'
import styles from './TagsSection.module.css'
import {modelsCatalogPath} from '@github-ui/paths'

interface TagsSectionProps {
  labels: Labels
  headingLevel?: 'h2' | 'h3'
}

export function TagsSection({labels: {tags, task}, headingLevel = 'h3'}: TagsSectionProps) {
  return (
    <div className={styles.tagsSection} {...testIdProps('tags-section')}>
      <SidebarHeading htmlTag={headingLevel} title="Tags" count={task ? tags.length + 1 : tags.length} />
      {(tags.length > 0 || task) && (
        <div className={styles.categories}>
          {tags.map(tag => {
            return (
              /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
              <a href={modelsCatalogPath({category: tag})} key={tag} className="topic-tag topic-tag-link" tabIndex={0}>
                {tag}
              </a>
            )
          })}

          {task && (
            /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
            <a href={modelsCatalogPath({task})} key={task} className="topic-tag topic-tag-link" tabIndex={0}>
              {task}
            </a>
          )}
        </div>
      )}
    </div>
  )
}
